<template>
  <div class="hot-column-nav">
    <a
      :key="index"
      @click="dealWith(configer)"
      class="hot-column-config"
      href="javascript:;"
      v-for="({configer}, index) in columnList"
    >
      <div class="config-img">
        <img alt v-lazy="configer.img" />
      </div>
      <div class="config-name">{{configer.title}}</div>
    </a>
  </div>
</template>

<script>
import api from '../../utils/api'
export default {
  name: 'hotColumnsNav',
  props: {
    columnList: {
      type: Array
    }
  },
  methods: {
    dealWith (arg) {
      api.configJumpDetails(arg)
    }
  }
}
</script>

<style lang="less" scoped>
.hot-column-nav {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  .hot-column-config {
    .flex-column-center;
    margin-bottom: 0.33rem;
    margin-right: 0.23rem;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .config-img {
      width: 1.2rem;
      height: 1.2rem;
      img {
        object-fit: contain;
      }
    }
    .config-name {
      width: 1.6rem;
      .ellipsis2;
      padding-top: 0.32rem;
      font-size: @fz24;
      color: @base;
      text-align: center;
    }
  }
}
</style>
